import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiMail, FiLock, FiUser, FiPhone, FiMapPin, FiTool } from 'react-icons/fi';
import Input from '../components/Input';
import Button from '../components/Button';
import './Auth.css';

const Register = () => {
  const { register } = useAuth();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phone: '',
    gstNumber: '',
    city: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const shopData = {
      name: formData.name,
      email: formData.email,
      password: formData.password,
      phone: formData.phone,
      gstNumber: formData.gstNumber || undefined,
      address: {
        city: formData.city,
        state: 'Maharashtra',
        country: 'India',
      },
    };

    await register(shopData);
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-background"></div>
      
      <div className="auth-content">
        <div className="auth-card">
          <div className="auth-header">
            <div className="auth-logo">
              <FiTool />
            </div>
            <h1 className="auth-title">Create Account</h1>
            <p className="auth-subtitle">Register your HVAC shop</p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            <Input
              label="Shop Name"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="ABC HVAC Services"
              icon={<FiUser />}
              required
            />

            <div className="register-grid">
              <Input
                label="Email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="shop@example.com"
                icon={<FiMail />}
                required
              />

              <Input
                label="Phone"
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="9876543210"
                icon={<FiPhone />}
                required
              />
            </div>

            <Input
              label="Password"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Create a strong password"
              icon={<FiLock />}
              required
            />

            <div className="register-grid">
              <Input
                label="GST number"
                type="text"
                name="gstNumber"
                value={formData.gstNumber}
                onChange={handleChange}
                placeholder="e.g. 27AABCU9603R1ZM"
              />

              <Input
                label="City"
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="Mumbai"
                icon={<FiMapPin />}
                required
              />
            </div>

            <Button
              type="submit"
              variant="primary"
              size="lg"
              fullWidth
              loading={loading}
            >
              Create Account
            </Button>
          </form>

          <div className="auth-footer">
            <p>
              Already have an account?{' '}
              <Link to="/login" className="auth-link">
                Sign In
              </Link>
            </p>
          </div>
        </div>

        <div className="auth-info">
          <h2>Start Managing Today</h2>
          <p>Join hundreds of HVAC shops using our platform to streamline their operations</p>
          <ul className="feature-list">
            <li>✓ Easy setup in minutes</li>
            <li>✓ Comprehensive dashboard</li>
            <li>✓ Real-time inventory tracking</li>
            <li>✓ Professional reporting</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Register;
